
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

import Label           from '../Label';
import Button          from '../Button';
import Input           from '../Input';
import InputGroup      from '../InputGroup';
import InputSection    from '../InputSection';
import RadioOption     from '../RadioOption';
import InlineError     from '../InlineError';
import SelectBox       from '../SelectBox';

import * as paymentActions from '../../actions/payment';

import responseFormatter from '../../services/responseFormatter';
import paymentApi        from '../../services/payment';
import trimmer           from '../../services/trimmer';
import {scrollToElementId} from '../../services/dom/elementScroller';

import { reduxForm } from 'redux-form';

class BookingOrganisation extends React.Component {

    constructor() {

        super();

        this.state = {
            isShowingOtherField: false,
            referrer: "",
            otherReferrer: ""
        };
    }

    _validateOrganisation(values, dispatch) {

        function validateSuccess() {

            dispatch(paymentActions.proceedToDelegates(values));
            scrollToElementId('delegates');
        }

        function validateFailed(response) {

            scrollToElementId('organisation');
            throw responseFormatter.apiErrorsToFormErrors(response.data.errors);
        }

        return paymentApi.validateOrganisation(trimmer.trim(values))
            .then(validateSuccess, validateFailed);
    }

    _onChangeReferrer(event) {
        if(event.target.value === "other") {
            this.setState({ isShowingOtherField: true });
        } else {
            this.setState({ isShowingOtherField: false });
        }

        this.setState({ referrer: event.target.value });
    }

    render() {

        const {
            fields: {
                organisation_name,
                sector,
                booking_email,
                referrer,
                other_referrer
            }, valid, handleSubmit, submitting
        } = this.props;

        return (

            <form className={style['container']} onSubmit={ handleSubmit(this._validateOrganisation) }>

                <InputSection>

                    <InputGroup className={style['top-input']}>
                        <Label isRequired="true">
                            Name
                        </Label>
                        <Input { ...organisation_name } errors={ organisation_name.error } />
                        <InlineError errors={ organisation_name.error } />
                    </InputGroup>

                    <InputGroup>

                        <Label isRequired="true">Sector</Label>

                        <div>
                            <RadioOption
                                { ...sector }
                                checked={ sector.value === 'public' }
                                value="public"
                                labelText="Public"
                                className={style['radio-option']}
                            >
                            </RadioOption>

                            <RadioOption
                                { ...sector }
                                checked={ sector.value === 'private' }
                                value="private"
                                labelText="Private"
                                className={style['radio-option']}
                            >
                            </RadioOption>
                        </div>

                        <InlineError errors={ sector.error } />

                    </InputGroup>
                </InputSection>

                <InputSection>

                    <InputGroup>
                        <Label isRequired="true">Email Address of Person Booking</Label>
                        <Input { ...booking_email } type="email" errors={ booking_email.error } />
                        <InlineError errors={ booking_email.error } />
                    </InputGroup>

                </InputSection>

                <InputSection>

                    <div className={style['section-content']}>
                        <InputGroup>

                            <Label isRequired="true">Where did you hear about us?</Label>

                            <span styleName="select-wrapper--referrer">

                                <SelectBox {...referrer}
                                           name="referrer"
                                           onChange={ this._onChangeReferrer.bind(this) }
                                           value={this.state.referrer}
                                           className={style['referrer-select']}>

                                    <option value="cant_remember">Can't remember</option>
                                    <option value="invite">Email invitation</option>
                                    <option value="magazine">Magazine</option>
                                    <option value="word_of_mouth">Word of mouth</option>
                                    <option value="search">Search engine</option>
                                    <option value="other">Other...</option>

                                </SelectBox>

                        </span>

                            {this.state.isShowingOtherField &&
                            <Input {...other_referrer} errors={ other_referrer.error }/>
                            }

                            <InlineError errors={ other_referrer.error } />

                        </InputGroup>

                    </div>

                </InputSection>

                <div styleName="nav-button-container">

                    <Button disabled={ !valid || submitting }
                            styleName="proceed-button"
                            type="submit">

                        <span>Next</span>

                    </Button>

                </div>

            </form>
        );
    }
}

function mapStateToProps(state) {

    return {
        ...state.payment,
        initialValues: state.payment.bookingValues
    };
}

const formParams = {
    form: 'booking-organisation',
    fields: [
        'organisation_name',
        'sector',
        'booking_email',
        'invoice_email',
        'referrer',
        'other_referrer'
    ]
};

export default reduxForm(formParams, mapStateToProps)(CSSModules(BookingOrganisation, style));


// WEBPACK FOOTER //
// ./components/BookingOrganisation/index.js